import { render, staticRenderFns } from "./SellerImportOrders.vue?vue&type=template&id=b80e86de&scoped=true"
import script from "./SellerImportOrders.vue?vue&type=script&lang=js"
export * from "./SellerImportOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80e86de",
  null
  
)

export default component.exports